/* Function
DESC: generateAuth returns the based-64 encoded string required to make protected calls to the Mappair and Zephyr APIs
*/
export const getAuth = () =>
  btoa(`${localStorage.getItem('user')}:${localStorage.getItem('key')}`);
